import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { skills } from '../../data/portfolio';

const Skills: React.FC = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <section
      id="skills"
      ref={ref}
      className="bg-slate-50/60 py-16 dark:bg-slate-950/60 sm:py-20"
      aria-labelledby="skills-heading"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between sm:gap-6">
          <div>
            <h2
              id="skills-heading"
              className="text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl md:text-3xl dark:text-slate-50"
            >
              Skills snapshot
            </h2>
            <p className="mt-2 max-w-xl text-sm text-slate-600 sm:text-base dark:text-slate-300">
              Focused on modern JavaScript, TypeScript, and Flutter with a strong
              interest in front-end craftsmanship and clean UX.
            </p>
          </div>
        </div>

        <div className="mt-6 grid gap-3 sm:mt-8 sm:gap-4 md:grid-cols-2">
          {skills.map((skill, index) => (
            <motion.div
              key={skill.name}
              initial={{ opacity: 0, y: 12 }}
              animate={
                inView
                  ? { opacity: 1, y: 0 }
                  : { opacity: 0, y: 12 }
              }
              transition={{ duration: 0.45, delay: index * 0.03, ease: 'easeOut' }}
              className="rounded-xl bg-white/80 p-4 shadow-sm ring-1 ring-slate-200/70 backdrop-blur-sm dark:bg-slate-900/80 dark:ring-slate-800"
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-900 dark:text-slate-50">
                    {skill.name}
                  </p>
                  <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                    {skill.category}
                  </p>
                </div>
                <p className="text-xs font-semibold text-slate-500 dark:text-slate-400">
                  {skill.level}%
                </p>
              </div>
              <div className="mt-3 h-1.5 w-full rounded-full bg-slate-100 dark:bg-slate-800">
                <div
                  className="h-1.5 rounded-full bg-gradient-to-r from-brand-pink via-brand-purple to-brand-orange"
                  style={{
                    width: inView ? `${skill.level}%` : '0%',
                    transition: 'width 0.7s ease-out',
                  }}
                  aria-hidden="true"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;



